import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=f4bb4b02&scoped=true&"
import script from "./Platform.vue?vue&type=script&lang=js&"
export * from "./Platform.vue?vue&type=script&lang=js&"
import style0 from "./Platform.vue?vue&type=style&index=0&id=f4bb4b02&lang=less&scoped=true&"
import style1 from "./Platform.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bb4b02",
  null
  
)

export default component.exports